import {
  PREDICTION,
  CLOSE,
  ACTUAL,
  SEEDATA,
  COMBINED,
  HISTOGRAM_CHART,
  BAR_CHART,
  SCATTERPLOT_CHART,
  LINE_CHART,
  GRAPH_CLEAR,
  PREDICTION_CLEAR,
  PARALLEL_COORDINATES_CHART
} from "./Constants";
import { fabric } from "fabric";
import { GraphPredictContext } from "./GraphPredictContext";
import * as React from "react";
import { Menu, Message } from "semantic-ui-react";
import { extent as d3ArrayExtent, histogram } from "d3-array";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import { min as d3min, max as d3max } from "d3";
import {
  scaleLinear as d3ScaleLinear,
  scalePoint as d3ScalePoint
} from "d3-scale";
import { select as d3Select, selectAll as d3SelectAll } from "d3-selection";
import { line as d3Line } from "d3-shape";
import "../../../css/ScatterPlot.css";
import * as aggregation from "../aggregation/countAggregation";
import { func } from "prop-types";
import "css-toggle-switch/dist/toggle-switch-px.css";
import "../../../css/modifiedSwitchToggle.css";
import PredictionToolBox from "./PredictionToolBox";
import ActualToolBox from "./AcutalToolBox";
import CombinedToolBax from "./CombinedToolBox";
import "../../../css/external/font-awesome.css";
import { Icon } from 'semantic-ui-react'
import { useState } from "react";
import {
  histogramPredictionDataset,
  BrushingPointsScatterPlot,
  brushingDataset,
  PredictionPointsScatterPlot,
  BrushingDataSet,
  HistogramPrediction
} from "../../Globals/Globals";

import { histogramBrush } from "../Brushing/HistogramBrush";
import { scatterPlotBrush } from "../Brushing/ScatterPlotBrush";
import { lineChartBrush } from "../Brushing/LineChartBrush";
import { barChartBrush } from "../Brushing/BarChartBrush";
import { parallelCoordinatesPlotBrush } from "../Brushing/ParallelCoordinatesBrush";
import {PREDICTION_COLOR,REALDATA_COLOR,BRUSHING_COLOR,NO_PREDICTION_COLOR} from "../../Globals/ColorConstants"
import {LogEvents, datasetMode} from '../../Globals/Globals'
import {PREDICITON_MODE, NOPREDICITON_MODE} from '../../Globals/Constants'

import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
  ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, 
  LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED} from '../../Globals/LogConstants'

  
interface MasterGraphConfigProps {
  masterid: string;
  id: string;
  width: number;
  height: number;
  valueChangeHandler: Function;
  yToolBoxMovement: number;
  graphType: string;
}
const MasterGraphConfig: React.FC<MasterGraphConfigProps> = ({
  id,
  width,
  height,
  yToolBoxMovement,
  valueChangeHandler,
  masterid,
  graphType
}) => {
  var tooloptions: any = "";


  const [activeItem, setActiveItem] = useState(PREDICTION)

  var y_movement = yToolBoxMovement;
  var MasterGraphConfigStyle;
  var MasterGraphConfigCloseStyle;
  if (
    graphType == BAR_CHART ||
    graphType == SCATTERPLOT_CHART ||
    graphType == LINE_CHART
  ) {
    MasterGraphConfigStyle = {
      float: "left",
      top: -15 + "px",
      left: 20,
      width: 380 + "px",
      height: 40 + "px",
      position: "absolute" as "absolute",
      borderWidth: 2,
      borderRadius: 5,
      borderColor: "black",
      transform: "translateY(" + y_movement + "px)"
    };
    MasterGraphConfigCloseStyle = {
      float: "left",
      top: 15 + "px",
      left: 20,
      width: 380 + "px",
      height: 40 + "px",
      position: "absolute" as "absolute",
      borderWidth: 2,
      borderRadius: 5,
      borderColor: "black",
      transform: "translateY(" + y_movement + "px)"
    }
  } else {
    MasterGraphConfigStyle = {
      float: "left",
      top: -65 + "px",
      left: 30,
      width: 380 + "px",
      height: 40 + "px",
      position: "absolute" as "absolute",
      borderWidth: 2,
      borderRadius: 5,
      borderColor: "black",
      transform: "translateY(" + y_movement + "px)"
    };
    MasterGraphConfigCloseStyle = {
      float: "left",
      top: 5 + "px",
      left: 30,
      width: 380 + "px",
      height: 40 + "px",
      position: "absolute" as "absolute",
      borderWidth: 2,
      borderRadius: 5,
      borderColor: "black",
      transform: "translateY(" + y_movement + "px)"
    }
  }

  const lablesStyle = {
    fontSize: "50%"
  };

  const toolbarStyle = {
    height: "30px",
    width: "380px",
    padding: "4px"
  };

  const messageToolbarStyle = {
    top: "30px",
    width: "300px",
    padding: "4px",

  };
  const {
    setgrapVisOptions,
    grapVisOptions,
    histogramOptions,
    sethistogramOptions,
    clearOptions,
    setclearOptions
  } = GraphPredictContext();



  const handleDeletePrediction = event => {

    var actualDataset = brushingDataset.getActualID(masterid);

    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
    if(logevents)
    {
      var eventlog = LogEvents.addEvent(masterid, graphType, null, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED , null, null,null,null,null)
      logevents._logEvents.push(eventlog)
      sessionStorage.setItem('logevents', JSON.stringify(logevents))
    }

    if (
      graphType == HISTOGRAM_CHART) {
      console.log('handleDeletePrediction', masterid, masterid + "_predictRect", histogramPredictionDataset.getPredictionMap().get(masterid + "_predictRect"))

      histogramPredictionDataset.removePrediction(masterid + "_predictRect");


      var elements = document.getElementsByClassName(masterid + "_predictRect")


      var arr = Array.from(elements)

      console.log('handleDeletePredictionelements arr', arr)
      var count = 1
      var histogrampred = histogramPredictionDataset.addPredictionID(masterid + "_predictRect")
      histogramPredictionDataset.addInitial(masterid + "_predictRect");
      arr.forEach(a => {
        a.setAttribute('height', (actualDataset.height - actualDataset.linearYScale(actualDataset.randomPredictSize)).toString())
        var xforms = a.getAttribute('transform');
        var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
        var firstX = parseFloat(parts[1]), firstY = actualDataset.linearYScale(actualDataset.randomPredictSize);
        a.setAttribute('transform',
          "translate(" +
          firstX +
          "," +
          firstY +
          ")"
        )

        var histogramPrediction: HistogramPrediction = new HistogramPrediction();

        histogramPrediction.setStopHeight(actualDataset.height);
        histogramPrediction.setlinearYScale(actualDataset.linearYScale);
        histogramPrediction.setlinearXScale(actualDataset.linearXScale);
        histogrampred
          .set(masterid + "_predictRect_" + count, histogramPrediction);

        count = count + 1
      });


    }
    else if (graphType == BAR_CHART || graphType == LINE_CHART) {

      if(graphType == BAR_CHART)
      {
       {
         
          histogramPredictionDataset.removePrediction(masterid + "_predictRect");
          var random = Math.max.apply(null, (Object.values(actualDataset.sumCategories)))
          var randomLength = Math.floor((random * 10) / 100);

          
          var histogram = histogramPredictionDataset
            .addPredictionID(masterid + "_predictRect")
          Object.keys(actualDataset.categoriesMap).map(function (e) {
            var histogramPrediction: HistogramPrediction = new HistogramPrediction();
  
  
            var element = document.getElementById(masterid + "_predictRect_" + e)
  
        
            var xforms = element.getAttribute('transform');
            var parts = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(xforms);
            var firstX = parseFloat(parts[1]), firstY = actualDataset.linearYScale(randomLength);
            element.setAttribute('height', (actualDataset.height - actualDataset.linearYScale(randomLength)).toString())
            element.setAttribute('transform',
              "translate(" +
              firstX +
              "," +
              firstY +
              ")"
            )
            console.log('firstY.toString()', firstY.toString(), randomLength)
            element.setAttribute('data-y','0')
            element.setAttribute('data-x','0')
            histogramPrediction.setStopHeight(actualDataset.height);
            histogramPrediction.setlinearYScale(actualDataset.linearYScale);
  
            histogram.set(masterid + "_predictRect_" + e, histogramPrediction);
            histogramPredictionDataset.addInitial(masterid + "_predictRect")
          })
        }
      }
      
      else if(graphType == LINE_CHART)
      {
        histogramPredictionDataset.removePredictionLineChart(masterid + "_lineChart")
        document.getElementById(masterid + "_pre_line_path").setAttribute("d","")
        

      }






    }
    else if (graphType == SCATTERPLOT_CHART) {
      console.log('deletion')

      var canvas_id = id.slice(0, id.lastIndexOf("_")) + "_canvas";
      if (histogramPredictionDataset.getPredictionScatterPlot(canvas_id) != null) {
        var scatterplotPrediction = histogramPredictionDataset.getPredictionScatterPlot(canvas_id)
        scatterplotPrediction.fabricCanvasInst.clear()
        scatterplotPrediction.fabricCanvasInst.backgroundColor = '#efefef';
       

        var mousecursor = new fabric.Circle({ 
          left: -100, 
          top: -100, 
          radius: scatterplotPrediction.fabricCanvasInst.freeDrawingBrush.width / 2, 
          fill: PREDICTION_COLOR, 
          stroke: "black",
          originX: 'center', 
          originY: 'center',
        
        });

       

      }
    }
      else if(graphType == PARALLEL_COORDINATES_CHART)
      {
        console.log('id.slice(0, id.lastIndexOf("_"))',document.getElementById(id.slice(0, id.lastIndexOf("_"))+'prediction'))
        var nodeDelete = document.getElementById(id.slice(0, id.lastIndexOf("_"))+'prediction')
        while (nodeDelete.firstChild) {
          nodeDelete.removeChild(nodeDelete.firstChild);
        }
        document.getElementById(id.slice(0, id.lastIndexOf("_"))+'prediction').remove()
      
        //d3SelectAll('#'+id.slice(0, id.lastIndexOf("_"))+'prediction').remove()
      }

    
  };

  var graphOptions = grapVisOptions["graphOptions"];
  var handleClickGraphOptions = (e, { name }) => {
    var child_id = id.slice(0, id.lastIndexOf("_"))
    var plain_id = child_id.split('_')[1]

    console.log(name);
    if (
      graphType == HISTOGRAM_CHART ||
      graphType == BAR_CHART ||
      graphType == SCATTERPLOT_CHART ||
      graphType == LINE_CHART || 
      graphType == PARALLEL_COORDINATES_CHART
    ) {
      if (name == GRAPH_CLEAR) {

      

        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        {
          
          var eventlog = LogEvents.addEvent(child_id, graphType, null, LOG_EVENT_TYPE_CHART_DESTROYED , null, null,null,null,null)
          logevents._logEvents.push(eventlog)
          sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }


    
        const nodeToDelete = document.getElementsByClassName("graph_parent_" + plain_id)[0];
        
        while (nodeToDelete.firstChild) {
          nodeToDelete.removeChild(nodeToDelete.firstChild);
        }
        document.getElementsByClassName("graph_parent_" + plain_id)[0].remove()

        if(BrushingDataSet.currentGraphID==child_id)
        {
          if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
          {
            
            histogramBrush(2, BrushingDataSet.currentGraphID, "none", brushingDataset);
          }
  
          if(BrushingDataSet.currentGraphType == BAR_CHART)
          {
            
            barChartBrush(2, BrushingDataSet.currentGraphID, null, brushingDataset);
          }
  
          if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
          {
            
            scatterPlotBrush(2, BrushingDataSet.currentGraphID, "none", brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == LINE_CHART)
          {
            
            lineChartBrush(2, BrushingDataSet.currentGraphID, null, brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
          {
            
            parallelCoordinatesPlotBrush(2, BrushingDataSet.currentGraphID, "none");
          }
          BrushingDataSet.currentGraphType = ''
          BrushingDataSet.currentGraphData = ''
          BrushingDataSet.currentGraphEnable = 2
          BrushingDataSet.currentGraphID = ''
        }

       

      }
      else if (name == PREDICTION) {


        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        {
          console.log(".graph_parent_" + plain_id, child_id)
          var eventlog = LogEvents.addEvent(child_id, graphType, null, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE , null, null,null,null,null)
          logevents._logEvents.push(eventlog)
          sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }

        if(BrushingDataSet.currentGraphID==id.slice(0, id.lastIndexOf("_")))
        {
        clearAllBrushes()
        }
        grapVisOptions["graphOptions"] = PREDICTION;

        const graphVis = { ...grapVisOptions };
        setgrapVisOptions(graphVis);
        setActiveItem(PREDICTION)
      } else if (name == SEEDATA) {
        
        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        {
          var eventlog = LogEvents.addEvent(child_id, graphType, null, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE , null, null,null,null,null)
          logevents._logEvents.push(eventlog)
          sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }

        if (graphType == SCATTERPLOT_CHART) {
          var canvas_id = id.slice(0, id.lastIndexOf("_")) + "_canvas";
          var predictionPointsScatterPlotArray = histogramPredictionDataset.getPredictionScatterPlot(
            canvas_id
          );
          if (predictionPointsScatterPlotArray == null) {
            predictionPointsScatterPlotArray = histogramPredictionDataset.addPredictionScatterPlot(
              canvas_id
            );
          }
          console.log('predictionPointsScatterPlotArray',predictionPointsScatterPlotArray)
          if(predictionPointsScatterPlotArray)
          {
            var canvasElement = document.getElementById(
              canvas_id
            ) as HTMLCanvasElement;
            if (canvasElement != null) {
              var autualDataset = brushingDataset.getActualID(
                id.slice(0, id.lastIndexOf("_"))
              );
              if (autualDataset != null) {
                var ctx = canvasElement.getContext("2d");
                ctx.save();
                predictionPointsScatterPlotArray.imageData = ctx;
                predictionPointsScatterPlotArray.imageURI = predictionPointsScatterPlotArray.fabricCanvasInst.toDataURL()
  
              }
            }
          }
         
        }
        if (graphType == PARALLEL_COORDINATES_CHART) {

          console.log('id.slice(0, id.lastIndexOf("_"))',document.getElementById(id.slice(0, id.lastIndexOf("_"))+'prediction'))
          var nodeDelete = document.getElementById(id.slice(0, id.lastIndexOf("_"))+'prediction')
          if(nodeDelete !=null)
          {
            while (nodeDelete.firstChild) {
              nodeDelete.removeChild(nodeDelete.firstChild);
            }
            document.getElementById(id.slice(0, id.lastIndexOf("_"))+'prediction').remove()
          }
          
          if(histogramPredictionDataset.getPredictionParallelCoordinatesChart(id.slice(0, id.lastIndexOf("_"))))
          {
            var parallelCoordinatesPrediction = histogramPredictionDataset.getPredictionParallelCoordinatesChart(id.slice(0, id.lastIndexOf("_")))
            console.log('parallelCoordinatesPrediction',parallelCoordinatesPrediction)
            var parallelCoordinatesBrushG = document.getElementById(id.slice(0, id.lastIndexOf("_"))+'_svg_parallel_coordinates')
            var brushes = parallelCoordinatesBrushG.querySelectorAll('.parallelCoordinatesbrush')
            for(var i=0; i<brushes.length; i++)
            {
              var axis = brushes[i].id.split('_')[0]
              console.log('parallelCoordinatesbrush',axis,brushes[i] )
              parallelCoordinatesPrediction.htmlElements[axis] =  brushes[i].childNodes
            }
         
           
          }
        

        }

        grapVisOptions["graphOptions"] = SEEDATA;
        
        const graphVis = { ...grapVisOptions };
        console.log('mastergraphconfiggraphVis',graphVis)
        setgrapVisOptions(graphVis);
        setActiveItem(SEEDATA)
      }
    }
  };

  if (graphType == HISTOGRAM_CHART) {
    if (graphOptions == PREDICTION || graphOptions == SEEDATA) {
      tooloptions = (
        <PredictionToolBox id={id} masterid={masterid} ></PredictionToolBox>
      );
    }
  } else if (graphType == BAR_CHART) {
    tooloptions = "";
  } else if (graphType == SCATTERPLOT_CHART) {
    tooloptions = "";
  } else if (graphType == LINE_CHART) {
    tooloptions = "";
  }
  var graphClearIcon
  if (graphOptions == PREDICTION) {
    if (
    
      graphType == PARALLEL_COORDINATES_CHART
    ) {
      graphClearIcon = ''
    }
    else
    {
      graphClearIcon  = <div style={MasterGraphConfigCloseStyle} className={masterid + "_menu2"}>
      <Menu secondary size={"mini"}>
        <Menu.Item position='right'
          name={PREDICTION_CLEAR}
          onClick={handleDeletePrediction}
          fitted
        >
          <Icon name='trash' />
        </Menu.Item>

      </Menu></div>
    }

   
  }
  if(datasetMode.mode == NOPREDICITON_MODE)
  {
    return (
      <>
        <div style={MasterGraphConfigStyle} className={id + " " + masterid + "_menu1"}>
          <Menu secondary fixed={"left"} style={toolbarStyle}>
            <Menu.Item size={"mini"} position='left'
              name={GRAPH_CLEAR}
              onClick={handleClickGraphOptions}
              fitted
            >
              <Icon name='close' />
            </Menu.Item>
  
            <Menu.Item
              size={"tiny"}
              name={SEEDATA}
              active={activeItem === SEEDATA}
              onClick={handleClickGraphOptions}
              color={"purple"}
              style={{ padding: "5px" }}
            >
              See Data
            </Menu.Item>
          </Menu>
  
          {tooloptions}
  
        </div>
  
        {graphClearIcon}
  
      </>
    );
  }
  else if(datasetMode.mode == PREDICITON_MODE)
  {
    return (
      <>
        <div style={MasterGraphConfigStyle} className={id + " " + masterid + "_menu1"}>
          <Menu secondary fixed={"left"} style={toolbarStyle}>
            <Menu.Item size={"mini"} position='left'
              name={GRAPH_CLEAR}
              onClick={handleClickGraphOptions}
              fitted
            >
              <Icon name='close' />
            </Menu.Item>
  
            <Menu.Item
            size={"tiny"}
            name={PREDICTION}
            active={activeItem === PREDICTION}
            onClick={handleClickGraphOptions}
            style={{ padding: "5px" }}
            color={"purple"}
          >
            Prediction
          </Menu.Item>

          <Menu.Item
            size={"tiny"}
            name={SEEDATA}
            active={activeItem === SEEDATA}
            onClick={handleClickGraphOptions}
            color={"purple"}
            style={{ padding: "5px" }}
          >
            See Data
          </Menu.Item>
          </Menu>
  
          {tooloptions}
  
        </div>
  
        {graphClearIcon}
  
      </>
    );
  }
  
};

/* 
// only SEEDATA IS enabled
<Menu.Item
            size={"tiny"}
            name={PREDICTION}
            active={activeItem === PREDICTION}
            onClick={handleClickGraphOptions}
            style={{ padding: "5px" }}
            color={"purple"}
          >
            Prediction
          </Menu.Item>

          <Menu.Item
            size={"tiny"}
            name={SEEDATA}
            active={activeItem === SEEDATA}
            onClick={handleClickGraphOptions}
            color={"purple"}
            style={{ padding: "5px" }}
          >
            See Data
          </Menu.Item>

<Message size={"mini"} style={messageToolbarStyle} >
             <p id={masterid+'_filter'} className={'filterBrush'} >Filter : </p>
     
       </Message>*/

export default MasterGraphConfig;

export function clearAllBrushes(){
          console.log('brushX',BrushingDataSet.currentGraphType, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphBrushInstance)
       
          if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
          {
            
            d3Select("#"+BrushingDataSet.currentGraphID+"brushX").call( BrushingDataSet.currentGraphBrushInstance.move, null);
            d3SelectAll('.brushon').attr('style', "fill:" + REALDATA_COLOR)
            d3SelectAll('.brushon').classed('brushon', false);
            histogramBrush(2, BrushingDataSet.currentGraphID, "none", brushingDataset);
          }
  
          if(BrushingDataSet.currentGraphType == BAR_CHART)
          {
            d3SelectAll('.brushon').attr('style', "fill:" + REALDATA_COLOR)
            d3SelectAll('.brushon').classed('brushon', false);
            brushingDataset.emptyBrushingScatterPlotArray()
            barChartBrush(2, BrushingDataSet.currentGraphID, null, brushingDataset);
          }
  
          if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
          {
         
            d3Select("."+BrushingDataSet.currentGraphID+"_svg_scatterplot_draw_g").call(BrushingDataSet.currentGraphBrushInstance.move, null);
           
            d3SelectAll("."+BrushingDataSet.currentGraphID + "_svg_scatterplot_draw_g_circle").attr("style","opacity: 0.5, fill:" +REALDATA_COLOR)
          
            scatterPlotBrush(2, BrushingDataSet.currentGraphID, "none", brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == LINE_CHART)
          {
            d3Select("#"+BrushingDataSet.currentGraphID + "_brushingelement").remove()
            d3Select("#"+BrushingDataSet.currentGraphID+"brushX").call( BrushingDataSet.currentGraphBrushInstance.move, null);
            lineChartBrush(2, BrushingDataSet.currentGraphID, null, brushingDataset);
          }
          if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
          {
            console.log('_parallelCoordinatesbrush', d3SelectAll("."+BrushingDataSet.currentGraphID+"_parallelCoordinatesbrush"))
            d3SelectAll("."+BrushingDataSet.currentGraphID+"_parallelCoordinatesbrush")
            .each(function(d) {
              console.log('_parallelCoordinatesbrush_parallelCoordinatesbrush',BrushingDataSet.currentGraphBrushInstance[d3Select(this).attr('id')])
              d3Select(this).call(BrushingDataSet.currentGraphBrushInstance[d3Select(this).attr('id')].move, null)
            
          
            })
           
            parallelCoordinatesPlotBrush(2, BrushingDataSet.currentGraphID, "none");
          }

        
}